// Vendor Imports
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import * as bootstrap from 'bootstrap';
//import 'select2';  // Импорт select2
//window.select2 = select2;
window.bootstrap = bootstrap
//import GLightbox from 'glightbox';
import './misc';

// Framework import.
//import './components/swiper';
//import './components/popover';
/*import './components/aos';
import './components/choices';
import './components/checkout';
import './components/hotspots';
import './components/image-zoom';
import './components/navbar';
import './components/nouislider';
import './components/offcanvas';

import './components/product';
import './components/scroll-to';
import './components/search';
import './components/simplebar';

import './components/tooltip';

// theme misc js
*/
